import React, { useEffect } from 'react'
import {
  Route,
  Switch,
  withRouter
} from 'react-router-dom'
import classnames from 'classnames'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'

// contexts
import { useAppState } from '../../contexts/AppStateContext'
import { useClient } from '../../contexts/ClientContext'
import { useLayoutState } from '../../contexts/LayoutContext'

// styles
import useStyles from './styles'

// components
import Header from '../Header'
import Sidebar from '../Sidebar'

// pages
import Dashboard from '../../pages/dashboard'
import Debugger from '../../pages/debugger'
import LogDetails from '../../pages/logDetails'
import AlarmTracker from '../../pages/alarmTracker'

function Layout (props) {
  const classes = useStyles()

  // global
  const layoutState = useLayoutState()
  const { globalProcessing, appInitialized } = useAppState()
  const { client } = useClient()

  const { history } = props

  if (history.location.search) {
    history.push({ search: undefined })
  }

  useEffect(() => {
    if (appInitialized && !client) {
      history.push('/app/dashboard')
    }
  }, [appInitialized, client])

  return (
    <div className={classes.root}>
        <>
          {globalProcessing &&
            <Backdrop className={classes.backdrop} open invisible={!appInitialized}>
              <CircularProgress />
            </Backdrop>
          }
          {appInitialized && <Header history={props.history} />}
          {appInitialized && client && <Sidebar />}
          {appInitialized &&
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened
            })}
          >
            <div className={classes.fakeToolbar} />
            <Switch>
              <Route path="/app/dashboard" component={Dashboard} />
              <Route path="/app/debugger" component={Debugger} />
              <Route path="/app/alarmtracker" component={AlarmTracker} />
              <Route path="/app/logs/:id" component={LogDetails} />
            </Switch>
          </div>}
        </>
    </div>
  )
}

export default withRouter(Layout)
